import { render } from "./OrderManagement.vue?vue&type=template&id=580ee276&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-580ee276"

export default script